var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hidden)?_c('img',{staticClass:"copyright",class:{ 'portrait': _vm.isPortrait, 'rigid': _vm.rigid },attrs:{"src":_vm.$image('copyright.svg'),"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }